export default class RatesCalculator {

    /**
     *
     * @param $content {jQuery}
     */
    constructor($content) {
        this.$content = $content;
        this.$input_content = this.$content.find(".input-content");
        this.$output_content = this.$content.find(".output-content");
        this.$start_again_btn = this.$content.find("#start_again_btn");
        this.$back_btn = this.$content.find("#back_btn");


        this.$contribution_txt = this.$input_content.find("#contribution_txt");
        this.$submit_contribution_btn = this.$input_content.find("#submit_contribution_btn");
        this.$submit_contribution_error = this.$input_content.find("#submit_contribution_error");

//rate-item-btn
        this.$canvas = this.$output_content.find("canvas");

        this.$user_contribution = this.$output_content.find(".user-contribution");
        this.$local_contribution = this.$output_content.find(".local-contribution");
        this.$rates_tables = this.$output_content.find(".rates-table");
        this.$rate_item_btns = this.$output_content.find(".rate-item-btn");
        this.$current_group_contribution = this.$output_content.find(".current-group-contribution");

        this.$previous_buttons = this.$content.find(".go-previous-category");
        this.$next_buttons = this.$content.find(".go-next-category");

        this.chart = null;
        this.central_government_prop = [];
        this.local_government_prop = [];
        this.rates_overview = [];
        this.current_total_contribution = 0;
        this.current_local_contribution = 0;
        this.calculated_breakdown = [];
        this.breakdown_items_by_id = {};
        this.current_parent_item_id = null;
        this.have_data_content = false;
        this.determine_values();
        this.init_screens();
    }

    init_screens() {
        this.$content.removeClass("hide");
        this.show_input();
        this.add_listeners();
    }

    submit_contribution(value) {
        let total_contribution = value ? this.twp_dp(parseFloat(value)) : 0;
        let min = this.$contribution_txt.attr("min");
        let max = this.$contribution_txt.attr("max");
        min = min ? parseFloat(min) : 0;
        max = max ? parseFloat(max) : 0;
        if (max && (total_contribution < min || total_contribution > max)) {
            this.$submit_contribution_error.html("Please enter a value between " + this.currency_format(min, true) + " and " + this.currency_format(max, true));
            this.$submit_contribution_error.show();
            return;
        }
        if (!value) {
            this.$submit_contribution_error.html("Please enter a value");
            this.$submit_contribution_error.show();
            return;
        }
        this.current_total_contribution = total_contribution;
        let data_error = this.apply_current_total_contribution();
        if (data_error) {
            this.$submit_contribution_error.html(data_error);
            this.$submit_contribution_error.show();
            return;
        }
        this.show_output();
    }

    add_listeners() {
        this.$submit_contribution_btn.click((event) => {
            event.preventDefault();
            this.submit_contribution(this.$contribution_txt.val());
            return false;
        })
        this.$start_again_btn.click((event) => {
            event.preventDefault();
            this.show_input();
            return false;
        })
        this.$back_btn.click((event) => {
            event.preventDefault();
            let breakdown_item = this.breakdown_items_by_id[this.current_parent_item_id];
            let parent_id = breakdown_item && breakdown_item.parent_id ? breakdown_item.parent_id : null;
            this.show_data_content(parent_id);
            return false;
        })
        this.$previous_buttons.click((event) => {
            event.preventDefault();
            let the_closest = $(event.target).closest('.show-for-rate-item');
            let the_prev = the_closest.prev('.show-for-rate-item');
            let the_prev_data_id = the_closest.siblings('.show-for-rate-item').last().data("rate-item-id");
            if (the_prev.length)
            {
                the_prev_data_id = the_prev.data("rate-item-id");
            }
            
            this.show_data_content(the_prev_data_id);
        })
        this.$next_buttons.click((event) => {
            event.preventDefault();
            let the_closest = $(event.target).closest('.show-for-rate-item');
            let the_next = the_closest.next('.show-for-rate-item');
            let the_next_data_id = the_closest.siblings('.show-for-rate-item').first().data("rate-item-id");
            if (the_next.length)
            {
                the_next_data_id = the_next.data("rate-item-id");
            }
            this.show_data_content(the_next_data_id);
            return false;
        })
        this.$rate_item_btns.click((event) => {
            event.preventDefault();
            this.show_data_content($(event.target).closest( "[data-rate-item-id]" ).data("rate-item-id"));
            return false;
        })
    }


    show_input() {
        this.$input_content.show();
        this.$output_content.hide();
        this.$submit_contribution_error.html("");
        this.$submit_contribution_error.hide();
        this.$start_again_btn.hide();
    }

    show_output() {
        this.$input_content.hide();
        this.$output_content.show();
        this.$start_again_btn.show();
        this.have_data_content = false;
        this.show_data_content(null);
    }

    twp_dp(value) {
        return Math.round(value * 100) / 100;
    }

    currency_format(num, include_symbol) {
        return (include_symbol ? "£" : "") + (parseFloat(num)).toFixed(2).replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,')
    }


    apply_current_total_contribution() {

        this.$user_contribution.html(this.currency_format(this.current_total_contribution, true));
        

        this.determine_local_contribution();
        this.calculated_breakdown = this.determine_proportional_contribution(this.rates_overview, this.current_local_contribution, this.local_government_prop, null);
        if (!this.calculated_breakdown) {
            return "Data Error";
        }
        this.breakdown_items_by_id = {};
        this.collect_breakdown_items_by_id(this.calculated_breakdown);
        this.apply_to_rates_table();
        return null;
    }

    determine_local_contribution() {
        this.current_local_contribution = this.twp_dp(this.current_total_contribution * this.local_government_prop);
        this.$local_contribution.html(this.currency_format(this.current_local_contribution, true));
        let $cat_total_contribution = this.$rates_tables.filter("[data-parent-item-id='none']").find(".catTotalContribution");
        $cat_total_contribution.html(this.currency_format(this.current_local_contribution, true));
    }

    determine_proportional_contribution(items, overall_contribution, parent_prop, parent_id) {

        let rounded_up = [];
        let rounded_down = [];
        let contribution_breakdown = [];

        let rounded_contribution = 0;

        for (let i = 0; i < items.length; i++) {
            let item = items[i];
            let prop = item.prop ? parseFloat(item.prop) : 0;
            let item_contribution = overall_contribution * prop
            let rounded_item_contribution = Math.round(item_contribution * 100) / 100;
            let round_diff = item_contribution - rounded_item_contribution;
            if (round_diff < 0) {
                rounded_up.push({i: i, round_diff: Math.abs(round_diff)});
            } else if (round_diff > 0) {
                rounded_down.push({i: i, round_diff: round_diff});
            }
            rounded_contribution = this.twp_dp(rounded_contribution + rounded_item_contribution);
            contribution_breakdown.push({
                contribution: rounded_item_contribution,
                item: item
            })
        }

        if (rounded_contribution > overall_contribution) {
            rounded_up.sort((a, b) => {
                return a.round_diff > b.round_diff ? -1 : 1;
            })
            for (let i = 0; i < rounded_up.length; i++) {
                let target = this.twp_dp(rounded_contribution - 0.01);
                if (target < overall_contribution) {
                    break;
                }
                rounded_contribution = target;
                contribution_breakdown[rounded_up[i].i].contribution = this.twp_dp(contribution_breakdown[rounded_up[i].i].contribution - 0.01);
            }
            if (rounded_contribution > overall_contribution) {
                return null;
            }
        } else if (rounded_contribution < overall_contribution) {
            if (this.twp_dp(rounded_contribution + rounded_down.length * 0.01 + 0.01) >= overall_contribution) {
                rounded_down.sort((a, b) => {
                    return a.round_diff > b.round_diff ? -1 : 1;
                })
                for (let i = 0; i < rounded_down.length; i++) {
                    let target = this.twp_dp(rounded_contribution + 0.01);
                    if (target > overall_contribution) {
                        break;
                    }
                    rounded_contribution = target;
                    contribution_breakdown[rounded_down[i].i].contribution = this.twp_dp(contribution_breakdown[rounded_down[i].i].contribution + 0.01);
                }
            }
        }

        if (rounded_contribution < overall_contribution - 0.01) {
            contribution_breakdown.push({
                contribution: overall_contribution - rounded_contribution,
                item: {
                    label: "Other",
                    id: (parent_id ? parent_id +"-" : "")+"other"
                }
            });
        }

        for(let i = 0; i < contribution_breakdown.length; i ++){
            let breakdown_item = contribution_breakdown[i];
            breakdown_item.overall_prop = parent_prop * (breakdown_item.contribution / overall_contribution)
            if(breakdown_item.item.sub_categories && Array.isArray(breakdown_item.item.sub_categories) && breakdown_item.item.sub_categories.length){
                breakdown_item.sub = this.determine_proportional_contribution(breakdown_item.item.sub_categories, breakdown_item.contribution, breakdown_item.overall_prop, breakdown_item.item.id);
            }
            breakdown_item.parent_id = parent_id;
        }
        return contribution_breakdown;
    }

    collect_breakdown_items_by_id(contribution_breakdown) {
        for(let i = 0; i < contribution_breakdown.length; i ++) {
            let breakdown_item = contribution_breakdown[i];
            if(breakdown_item.sub){
                this.collect_breakdown_items_by_id(breakdown_item.sub);
            }
            this.breakdown_items_by_id[breakdown_item.item.id] = breakdown_item;
        }
    }

    apply_to_rates_table() {
        for(let item_id in this.breakdown_items_by_id){
            let breakdown_item = this.breakdown_items_by_id[item_id];
            let $row = this.$rates_tables.find("[data-rate-item-id='" + item_id + "'] td.contribution");
            $row.html(this.currency_format(breakdown_item.contribution, true));
            let $cat_total_contribution = this.$rates_tables.filter("[data-parent-item-id='" + item_id + "']").find(".catTotalContribution");
            $cat_total_contribution.html(this.currency_format(breakdown_item.contribution, true));
        }
    }

    show_data_content(item_id) {
        let $content_items = $(".show-for-rate-item");
        $content_items.hide();

        let current_parent_item_id = null;

        if (item_id) {
            let check_id = item_id;
            while(true) {
                let breakdown_item = this.breakdown_items_by_id[check_id];
                if (!breakdown_item) {
                    break;
                }
                let $content_item = $content_items.filter("[data-rate-item-id='" + check_id + "']");
                if($content_item.length){
                    $content_item.show();
                    break;
                }
                if(!breakdown_item.parent_id){
                    break;
                }
                check_id = breakdown_item.parent_id;
            }

            check_id = item_id;
            while(true){
                let breakdown_item = this.breakdown_items_by_id[check_id];
                if(!breakdown_item){
                    break;
                }
                let value = breakdown_item ? breakdown_item.contribution : 0;
                this.$current_group_contribution.html(this.currency_format(value));
                if(breakdown_item.sub){
                    current_parent_item_id = check_id;
                    break;
                }
                if(!breakdown_item.parent_id){
                    break;
                }
                check_id = breakdown_item.parent_id;
            }
        }
        if(!this.have_data_content || current_parent_item_id !== this.current_parent_item_id){
            this.current_parent_item_id = current_parent_item_id;
            this.have_data_content = true;

            let $summary_category_line = $("#summary-category-line");
            $summary_category_line.hide();
            let $rates_table = $();

            if(this.current_parent_item_id){
                let breakdown_item = this.breakdown_items_by_id[this.current_parent_item_id];
                this.$start_again_btn.hide();
                this.$back_btn.show();
                this.create_chart(breakdown_item.sub, value);
                $rates_table = this.$rates_tables.filter("[data-parent-item-id='" + this.current_parent_item_id + "']");
                if($rates_table.length){
                    $summary_category_line.show();
                    $summary_category_line.find(".summary-category-name").html(breakdown_item.item.category_title)
                    $summary_category_line.find(".summary-category-contribution").html(this.currency_format(breakdown_item.contribution, true))
                    $summary_category_line.find(".summary-category-percentage").html(Math.round(breakdown_item.overall_prop * 10000) / 100)
                }
            } else {
                this.$start_again_btn.show();
                this.$back_btn.hide();
                this.create_chart(this.calculated_breakdown, this.current_local_contribution);
            }

            if(!$rates_table.length){
                $rates_table = this.$rates_tables.filter("[data-parent-item-id='none']")
            }
            this.$rates_tables.hide();
            $rates_table.show();

        }
    }

    create_chart(breakdown, total_contribution) {

        if($(window).width() >= 500){
            Chart.register(ChartDataLabels);
        }

        let labels = [];
        let data = [];
        let background_colors = [];


        let hover_indexes = [];
        for (let i = 0; i < breakdown.length; i++) {
            let item = breakdown[i];

            labels.push(item.item.name);
            data.push(item.contribution);
            if (item.item.background_color) {
                background_colors.push(item.item.background_color);
            }
            let do_hover = !!breakdown.sub;
            if(!do_hover){
                let $content_item = $(".show-for-rate-item[data-rate-item-id='" + item.item.id + "']");
                if($content_item.length){
                    do_hover = true;
                }
            }
            hover_indexes[i] = do_hover;
        }
        background_colors = background_colors.length === data.length ? background_colors : null;

        if (this.chart) {
            this.chart.destroy();
        }
        this.chart = new Chart(this.$canvas, {
            type: 'doughnut',
            data: {
                datasets: [{
                    data: data,
                    backgroundColor: background_colors
                }],
                labels: labels
            },
            options: {
                responsive: true,
                //maintainAspectRatio: false,
                onResize: (chart, size) => {
                    if(!size || !size.width){
                        return
                    }
                    chart.options.plugins.datalabels.display = size.width >= 420;
                },
                onClick: (event, context) => {
                    setTimeout(() => {
                        this.show_data_content(breakdown[context[0].index].item.id)
                    }, 1);
                },
                onHover: (event, context) => {
                    this.$canvas.css("cursor", context[0] && hover_indexes[context[0].index] ? "pointer" : "default");
                },
                plugins: {
                    legend: {
                        display: true,
                        position: 'bottom',
                        maxWidth : 420,
                        labels: {
                            usePointStyle: true,
                            font: function (context) {

                                let setSize = (context.chart.width > 400) ? 11 : 8.5;

                                //let avgSize = Math.round((context.chart.height + context.chart.width) / 2);
                                //let setSize = Math.round(avgSize / 32);
                                //setSize = setSize > 10 ? 10 : setSize; // setting max limit to 12
                                return {
                                    size: setSize,
                                    weight: 'normal',
                                    lineHeight: 1,
                                    family: 'Helvetica',
                                };
                            },
                        },
                        onClick: function (e) {
                            e.stopPropagation();
                        }

                    },

                    labels: {
                        render: 'label',
                        fontStyle: 'normal',
                        fontSize: 10,
                        fontColor: '#fff',
                        fontFamily: 'Helvetica',
                        arc: true,
                    },
                    datalabels: {
                        formatter:  (value, context) =>
                        {
                            let tmp_val = parseFloat( ((breakdown[context.dataIndex].contribution / total_contribution) * 100) ).toFixed(2)
                            return tmp_val + "%";
                        },
                        color: 'white',
                        font: {
                            weight: 'bold',
                            size: 15
                        },
                        padding: 15,
                        align: "center"
                    },
                    tooltip: {
                        callbacks: {
                            label: (context) => {
                                return " " +this.currency_format(context.parsed, true);
                            }
                        }
                    }

                }
            }
        });
    }

    determine_values() {

        if (typeof page_vars !== 'undefined' && page_vars && page_vars.rates_calculator_values) {
            let rates_calculator_values = page_vars.rates_calculator_values;
            this.central_government_prop = rates_calculator_values.central_government_prop ? parseFloat(rates_calculator_values.central_government_prop) : 0;
            this.local_government_prop = rates_calculator_values.local_government_prop ? parseFloat(rates_calculator_values.local_government_prop) : 0;
            this.rates_overview = rates_calculator_values.rates_overview ? rates_calculator_values.rates_overview : [];
        }
    }

}